class CartDrawer extends HTMLElement {

  constructor() {
    super();
    this.drawer = this.querySelector('[data-cart-drawer]');
    this.activeClass = 'cart-drawer-is-open';
    this.cartIconBubble = document.querySelector('cart-icon-bubble');
    this.closeButtons = this.querySelectorAll('[data-cart-button-close]');
    this.closeButtons.forEach((btn) => btn.addEventListener('click', this.close.bind(this)));
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.drawer.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());

    // When a user presses the back button, check if the cart is open
    if (history.pushState) {
      window.addEventListener('popstate', (event) => {
        if (document.body.classList.contains(this.activeClass)) {
          this.close();
        }
      });
    }
  }

  open() {
    // On opening the cart drawer, add extra history state to catch a back button
    if (history.pushState) {
      history.pushState(null, document.title, location.href);
    }

    document.body.classList.add(this.activeClass);
    this.cartIconBubble.toggleButton.setAttribute('aria-expanded', true);
    this.drawer.focus();
    trapFocus(this.drawer);
    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    document.body.classList.remove(this.activeClass);
    this.cartIconBubble.toggleButton.setAttribute('aria-expanded', false);
    document.body.removeEventListener('click', this.onBodyClick);
    removeTrapFocus();
  }

  renderContents(parsedState) {
    this.getSectionsToRender().forEach((section, index) => {
      document.querySelector(section.selector).innerHTML =
      this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });
    // Re-bind the close drawer buttons
    this.querySelectorAll('[data-cart-button-close]').forEach((btn) => btn.addEventListener('click', this.close.bind(this)));
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-cart-item-contents',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-cart-footer-contents',
      },
      {
        id: 'cart-icon-bubble',
        selector: '[data-cart-icon-bubble]',
      },
      {
        id: 'cart-drawer-icon-bubble',
        section: 'cart-drawer-icon-bubble',
        selector: '[data-cart-drawer-icon-bubble]',
      }
    ];
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
    .parseFromString(html, 'text/html')
    .querySelector(selector).innerHTML;
  }

  handleBodyClick(event) {
    const target = event.target;
    if (target !== this.drawer && !target.closest('cart-drawer')) {
      this.close();
    }
  }

}

if (!customElements.get('cart-drawer')) {
  customElements.define('cart-drawer', CartDrawer);
}
